import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {SureFlowRatingUnitRequest} from '../../../model/sure-flow-rating-unit-request';
import {SureFlowUnitData} from '../../../model/sure-flow-unit-data';
import {UnitConversionUtils} from '../../../configurator/unit-conversion-utils';
import {GuruEntity} from '../../../model/guru-entity';
import {StringUtils} from '../../../utils/string-utils';
import { PerformanceCoilInputsSectionComponent } from '../performance-coil-inputs-section/performance-coil-inputs-section.component';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-performance-inputs-section',
    templateUrl: './performance-inputs-section.component.html',
    styleUrls: ['./performance-inputs-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule, PerformanceCoilInputsSectionComponent]
})
export class PerformanceInputsSectionComponent implements OnChanges {

  readonly unitData = input.required<SureFlowUnitData>();
  readonly selectionChange = output<GuruEntity>();
  readonly targetChange = output<void>();
  canExpand: boolean = true;
  collapsed: boolean = false;
  request!: SureFlowRatingUnitRequest;

  ngOnChanges(changes: SimpleChanges): void {
    this.request = this.unitData().sureFlowRatingUnit.request;
    if (!StringUtils.equalsIgnoreCase('C', this.request?.fanSpeed)) {
      this.request.airflow = 0;
    }
  }

  localInputChanged(selectionName: string, value: string): void {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = selectionName;
    entity.Value = value;
    this.selectionChange.emit(entity);
  }

  inputChanged(entity: GuruEntity): void {
    this.selectionChange.emit(entity);
  }

  getEspUnits(): string {
    return UnitConversionUtils.getEspUnits(this.request.metric);
  }

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.request.metric);
  }

  getLengthUnits(): string {
    return UnitConversionUtils.getLengthUnits(this.request.metric);
  }

  getExpansionIcon(): string {
    return this.collapsed ? 'arrow_drop_down' : 'arrow_drop_up';
  }

  toggleExpansion(): void {
    if (this.canExpand) {
      this.collapsed = !this.collapsed;
    }
  }

  targetLoadChanged(): void {
    this.targetChange.emit();
  }

}
